<template>
  <div class="relative w-full">
    <Head
      v-if="$page.props.is_preview != true"
      :title="$page.props.product.name"
    />
    <Head v-else title="商品編輯結果預覽" />
    <ScrollTop />

    <div
      class="w-full mt-5"
      :class="{
        'mx-auto pt-2 pb-10 px-2 border border-fh-gray-light':
          $page.props.is_preview == true,
      }"
      :style="{
        width: $page.props.is_preview == true ? preview_width + 'px' : null,
      }"
    >
      <div v-if="$page.props.is_preview == true" class="w-full my-5">
        <div class="flex flex-row justify-center gap-4">
          <Button
            label="電腦"
            icon="pi pi-desktop"
            class="p-button-lg"
            @click="preview_width = 1000"
          />
          <Button
            label="手機"
            icon="pi pi-mobile"
            class="p-button-lg"
            @click="preview_width = 400"
          />
        </div>
        <div class="p-2 mx-auto my-4 border border-fh-gray-light">
          <i class="pi pi-desktop mr-1"></i>
          {{ $page.props.product.name }} | Foody Home 吃貨家
        </div>
        <div class="p-2 mx-auto my-4 border border-fh-gray-light">
          <i class="pi pi-link mr-1"></i>
          {{ route("product", $page.props.product.slug) }}
        </div>
      </div>
      <div class="w-full my-5">
        <Breadcrumb :home="breadcrumb_home" :model="breadcrumb_items" />
      </div>
      <div class="w-full mt-5 flex flex-wrap justify-around">
        <div class="basis-1/2 min-w-[350px]">
          <div class="inline_galleria">
            <Galleria
              :activeIndex.sync="activeIndex"
              :value="product_images"
              :numVisible="5"
              :circular="true"
              :showItemNavigators="true"
              :showItemNavigatorsOnHover="true"
              :autoPlay="true"
              :transitionInterval="5000"
              :showThumbnails="showThumbnailBar"
              class="mx-auto"
            >
              <template #item="slotProps">
                <div
                  class="bg-fh-gray-light bg-center bg-contain bg-no-repeat cursor-zoom-in block w-[400px] h-[400px]"
                  :style="
                    'background-image: url(\'/storage/product-images/' +
                    slotProps.item.hash +
                    '/400.jpg\')'
                  "
                  @click="showFullScreen = true"
                />
              </template>
              <template #thumbnail="slotProps">
                <div
                  class="bg-fh-gray-light bg-center bg-cover bg-no-repeat block w-[72px] h-[72px] overflow-hidden"
                  :style="
                    'background-image: url(\'/storage/product-images/' +
                    slotProps.item.hash +
                    '/100.jpg\')'
                  "
                />
              </template>
            </Galleria>
          </div>
          <div class="fullscreen_galleria">
            <Galleria
              :activeIndex.sync="activeIndex"
              :value="product_images"
              :numVisible="7"
              containerStyle="max-width: 100vh; max-height: 100vh"
              :circular="true"
              :fullScreen="true"
              :showItemNavigators="true"
              :showThumbnails="false"
              :visible.sync="showFullScreen"
            >
              <template #item="slotProps">
                <img
                  :src="
                    '/storage/product-images/' +
                    slotProps.item.hash +
                    '/original.jpg'
                  "
                  class="height: 100vh;"
                />
                <!-- <div
                  class="bg-center bg-contain bg-no-repeat block h-[100vh]"
                  :style="
                    'background-image: url(\'/storage/product-images/' +
                    slotProps.item.hash +
                    '/original.jpg\')'
                  "
                  @mouseover="autoPlay = false"
                  @mouseout="autoPlay = true"
                  @click="showFullScreen = true"
                /> -->
              </template>
              <template #thumbnail="slotProps">
                <div
                  class="bg-center bg-cover bg-no-repeat block w-[100px] h-[100px] overflow-hidden"
                  :style="
                    'background-image: url(\'/storage/product-images/' +
                    slotProps.item.hash +
                    '/100.jpg\')'
                  "
                />
              </template>
            </Galleria>
          </div>
        </div>
        <div
          class="editor_area basis-1/2 min-w-[350px] flex justify-start flex-col"
        >
          <div class="w-full text-3xl my-1 flex">
            {{ $page.props.product.name }}
            <span
              :class="delivery_type.class"
              class="rounded-full py-0.5 px-2 text-white text-sm items-center my-auto ml-2 whitespace-nowrap"
            >
              {{ delivery_type.name }}
            </span>
          </div>
          <div class="flex">
            <div
              :class="{ 'line-through': is_on_sale }"
              class="mr-2 py-2 text-3xl text-left"
            >
              {{
                parseInt(
                  $page.props.product.settings.discount.original_price ??
                    $page.props.product.price
                )
                  | commaFormat
                  | priceFormat
              }}
            </div>
            <div v-if="is_on_sale" class="py-2 text-3xl text-left text-red">
              {{
                parseInt($page.props.product.price) | commaFormat | priceFormat
              }}
            </div>
          </div>
          <div class="flex">
            <div
              :class="{ 'line-through': is_on_sale }"
              class="mr-2 py-2 text-3xl text-left"
            >
              cv{{
                parseInt(
                  $page.props.product.settings.discount.original_cv ??
                    $page.props.product.cv
                ) | commaFormat
              }}
            </div>
            <div v-if="is_on_sale" class="py-2 text-3xl text-left text-red">
              cv{{ parseInt($page.props.product.cv) | commaFormat }}
            </div>
          </div>
          <div
            v-if="is_on_sale && $page.props.product.settings.on_sale.enabled"
            class="py-2 text-xl text-left text-red"
          >
            {{ $page.props.product.settings.on_sale.name }}
          </div>
          <div class="w-20 py-1 px-2 bg-fh-blue text-white">商品規格</div>
          <div class="py-3 border-t-2 border-b-2 border-fh-gray-light">
            <div class="my-2">類型：{{ delivery_type.name }}</div>
            <div class="my-2" v-html="$page.props.product.specification"></div>
            <div class="mt-8">
              運費：{{
                parseInt(delivery_type.price) | commaFormat | priceFormat
              }}<span class="text-sm">（離島地區另酌收 $100 處理費）</span>
            </div>
            <div v-if="$page.props.free_shippings" class="mt-2 text-sm">
              <div>符合以下任一條件即可享免運優惠：</div>
              <div class="mt-1">
                <ul
                  class="text-red"
                  :key="'free_shipping_' + index"
                  v-for="(rule, index) in $page.props.free_shippings"
                >
                  <li>
                    （{{ phraseDeliveryMethod(rule.delivery_method)}}）
                    {{ rule.description }}：<template
                      v-if="rule.duration.enabled"
                      >活動期間（{{
                        dayjs(rule.duration.start).format("YYYY-MM-DD")
                      }}
                      至
                      {{
                        dayjs(rule.duration.end).format("YYYY-MM-DD")
                      }}）</template
                    ><template v-if="rule.condition.type == 'always'"
                      >無條件免運</template
                    ><template v-if="rule.condition.type == 'greater'"
                      >{{ delivery_type.name }}溫層合計金額大於
                      {{ rule.condition.amount | commaFormat | priceFormat }}
                    </template>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- 組合包 -->
          <div
            v-if="$page.props.product.type == 'pack'"
            class="py-3 border-b-2 border-fh-gray-light"
          >
            <!-- 組合包 -->
            <div>
              <template v-if="product.attributes?.type?.mode == 'fixed'">
                <!-- 固定 -->
                <div>包含以下商品：</div>
                <div class="my-2 h-[160px] overflow-auto">
                  <div
                    :key="item.id + '_' + index"
                    v-for="(item, index) in options"
                    class="flex flex-nowrap flex-row justify-start items-center my-1 cursor-zoom-in hover:bg-fh-gray-bg"
                    @click="goToProductPage(item.slug)"
                  >
                    <div class="w-[50px]">
                      <img
                        v-if="
                          Array.isArray(item.image) && item.image.length > 0
                        "
                        class="object-cover aspect-square pack-product-image"
                        :src="
                          '/storage/product-images/' + item.image[0] + '/50.jpg'
                        "
                      />
                      <img
                        v-else
                        class="object-cover aspect-square pack-product-image"
                        src="//dummyimage.com/50/ccc/666?text=%E5%90%83%E8%B2%A8%E5%AE%B6"
                      />
                    </div>
                    <div class="mx-3">{{ item.name }}</div>
                  </div>
                </div>
              </template>
              <template v-else>
                <template v-if="product.multiple !== true">
                  <!-- 單選 -->
                  <TabView :activeIndex.sync="tab_index">
                    <TabPanel
                      :header="
                        '選擇 (' + product.attributes.type.quantity + ')'
                      "
                    >
                      <div class="h-[160px] overflow-auto">
                        <div
                          :key="item.id + '_' + index"
                          v-for="(item, index) in options"
                          class="flex flex-nowrap flex-row justify-start items-center my-1 hover:bg-fh-gray-bg"
                        >
                          <div class="mr-2">
                            <Button
                              icon="pi pi-plus"
                              class="p-button-rounded p-button-text"
                              :disabled="check_single_selection(item)"
                              @click="select_item(item)"
                            />
                          </div>
                          <div class="w-[50px]">
                            <img
                              v-if="
                                Array.isArray(item.image) &&
                                item.image.length > 0
                              "
                              class="object-cover aspect-square pack-product-image"
                              :src="
                                '/storage/product-images/' +
                                item.image[0] +
                                '/50.jpg'
                              "
                            />
                            <img
                              v-else
                              class="object-cover aspect-square pack-product-image"
                              src="//dummyimage.com/50/ccc/666?text=%E5%90%83%E8%B2%A8%E5%AE%B6"
                            />
                          </div>
                          <div class="ml-3">{{ item.name }}</div>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel
                      :header="'已選 (' + selected.length + ')'"
                      :disabled="selected.length == 0"
                    >
                      <div class="h-[160px] overflow-auto">
                        <div
                          :key="item.id + '_' + index"
                          v-for="(item, index) in selected"
                          class="flex flex-nowrap flex-row justify-start items-center my-1 hover:bg-fh-gray-bg"
                        >
                          <div class="mr-2">
                            <Button
                              icon="pi pi-times"
                              class="p-button-rounded p-button-text"
                              @click="delete_item(index)"
                            />
                          </div>
                          <div class="w-[50px]">
                            <img
                              v-if="
                                Array.isArray(item.image) &&
                                item.image.length > 0
                              "
                              class="object-cover aspect-square pack-product-image"
                              :src="
                                '/storage/product-images/' +
                                item.image[0] +
                                '/50.jpg'
                              "
                            />
                            <img
                              v-else
                              class="object-cover aspect-square pack-product-image"
                              src="//dummyimage.com/50/ccc/666?text=%E5%90%83%E8%B2%A8%E5%AE%B6"
                            />
                          </div>
                          <div class="ml-3">{{ item.name }}</div>
                        </div>
                      </div>
                    </TabPanel>
                  </TabView>
                </template>
                <template v-else>
                  <!-- 多選 -->
                  <TabView :activeIndex.sync="tab_index">
                    <TabPanel
                      :header="
                        '選擇 (' + product.attributes.type.quantity + ')'
                      "
                    >
                      <div class="h-[160px] overflow-auto">
                        <div
                          :key="item.id + '_' + index"
                          v-for="(item, index) in options"
                          class="flex flex-nowrap flex-row justify-start items-center my-1 hover:bg-fh-gray-bg"
                        >
                          <div class="mr-2">
                            <Button
                              icon="pi pi-plus"
                              class="p-button-rounded p-button-text"
                              :disabled="check_multiple_selection(item)"
                              @click="select_item(item)"
                            />
                          </div>
                          <div class="w-[50px]">
                            <img
                              v-if="
                                Array.isArray(item.image) &&
                                item.image.length > 0
                              "
                              class="object-cover aspect-square pack-product-image"
                              :src="
                                '/storage/product-images/' +
                                item.image[0] +
                                '/50.jpg'
                              "
                            />
                            <img
                              v-else
                              class="object-cover aspect-square pack-product-image"
                              src="//dummyimage.com/50/ccc/666?text=%E5%90%83%E8%B2%A8%E5%AE%B6"
                            />
                          </div>
                          <div class="ml-3">{{ item.name }}</div>
                        </div>
                      </div>
                    </TabPanel>
                    <TabPanel
                      :header="'已選 (' + selected.length + ')'"
                      :disabled="selected.length == 0"
                    >
                      <div class="h-[160px] overflow-auto">
                        <div
                          :key="item.id + '_' + index"
                          v-for="(item, index) in selected"
                          class="flex flex-nowrap flex-row justify-start items-center my-1 hover:bg-fh-gray-bg"
                        >
                          <div class="mr-2">
                            <Button
                              icon="pi pi-times"
                              class="p-button-rounded p-button-text"
                              @click="delete_item(index)"
                            />
                          </div>
                          <div class="w-[50px]">
                            <img
                              v-if="
                                Array.isArray(item.image) &&
                                item.image.length > 0
                              "
                              class="object-cover aspect-square pack-product-image"
                              :src="
                                '/storage/product-images/' +
                                item.image[0] +
                                '/50.jpg'
                              "
                            />
                            <img
                              v-else
                              class="object-cover aspect-square pack-product-image"
                              src="//dummyimage.com/50/ccc/666?text=%E5%90%83%E8%B2%A8%E5%AE%B6"
                            />
                          </div>
                          <div class="ml-3">{{ item.name }}</div>
                        </div>
                      </div>
                    </TabPanel>
                  </TabView>
                </template>
              </template>
            </div>
            <!-- /組合包 -->
          </div>
          <div class="my-2 text-center">
            <div v-if="$page.props.product.quantity > 0">
              數量：
              <InputNumber
                ref="InputNumber"
                v-model="quantity"
                showButtons
                suffix="個"
                buttonLayout="horizontal"
                decrementButtonClass="shopping-cart-decrease_button !rounded-full !bg-fh-pink !text-white !w-5 !h-5 !p-2 !my-auto"
                incrementButtonClass="shopping-cart-increase_button !rounded-full !bg-fh-pink !text-white !w-5 !h-5 !p-2 !my-auto"
                incrementButtonIcon="pi pi-plus"
                decrementButtonIcon="pi
                  pi-minus"
                inputClass="shopping-cart-number_input"
                class="p-invalid"
                :max="$page.props.product.quantity"
                :min="$page.props.product.quantity == 0 ? 0 : 1"
                :disabled="
                  $page.props.is_preview == true ||
                  product.quantity == 0 ||
                  not_in_duration ||
                  (product.type == 'pack' &&
                    product.attributes?.type?.mode != 'fixed' &&
                    (should_disable || not_able_to_add))
                "
              />
            </div>
            <div v-else class="mt-2 text-fh-gray-light">商品已售完</div>
            <div
              class="my-2 text-center text-red text-sm"
              v-if="$page.props.product.attributes.is_long_lead ?? false"
            >
              商品備貨期較長，可能影響訂單出貨速度！
            </div>
            <div
              class="my-2 text-center text-red text-sm"
              v-if="this.product.settings?.time_limit ?? false"
            >
              {{ checkDuration() }}
            </div>
            <!-- @input="handleInputQuantityChange(slotProps.data)"
                          @focus="setUpdateShoppingCartValue(slotProps.data)"
                          @blur="updateShoppingCart(slotProps.data)" -->
          </div>

          <div class="flex my-5">
            <Button
              v-if="!$page.props.in_collection"
              label="加入收藏"
              class="p-button-outlined flex-1 !mr-1"
              :disabled="$page.props.is_preview == true"
              @click="addToCollection"
            />
            <Button
              v-else
              label="從收藏中移除"
              class="p-button-outlined flex-1 !mr-1"
              :disabled="$page.props.is_preview == true"
              @click="removeFromCollection"
            />
            <Button
              label="加入購物車"
              class="flex-1 !ml-1 !bg-fh-blue"
              :disabled="
                $page.props.is_preview == true ||
                product.quantity == 0 ||
                not_in_duration ||
                (product.type == 'pack' &&
                  product.attributes?.type?.mode != 'fixed' &&
                  (should_disable || not_able_to_add))
              "
              @click="addToShoppingCart"
            />
          </div>
        </div>
      </div>
      <div class="w-20 py-1 px-2 bg-fh-blue text-white">商品描述</div>
      <hr class="border border-fh-gray-light" />
      <div
        class="editor_area my-2"
        v-html="$page.props.product.description"
      ></div>
    </div>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import Breadcrumb from "@/Shared/Components/Breadcrumb";
import Galleria from "primevue/galleria";
import InputNumber from "primevue/inputnumber";
import Button from "primevue/button";
import ScrollTop from "primevue/scrolltop";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";

export default {
  components: {
    Breadcrumb,
    Galleria,
    InputNumber,
    Button,
    ScrollTop,
    TabView,
    TabPanel,
  },
  layout: Layout,
  props: {
    product: Object,
  },
  filters: {
    priceFormat: function (value) {
      return "$" + value;
    },
    commaFormat: function (value) {
      return value
        .toString()
        .replace(
          /^(-?\d+?)((?:\d{3})+)(?=\.\d+$|$)/,
          function (all, pre, groupOf3Digital) {
            return pre + groupOf3Digital.replace(/\d{3}/g, ",$&");
          }
        );
    },
  },
  data() {
    return {
      activeIndex: 0,
      showFullScreen: false,
      showThumbnailBar: true,
      quantity: this.$page.props.product.quantity == 0 ? 0 : 1,
      breadcrumb_home: {
        icon: "pi pi-home",
        to: "/",
        disabled: this.$page.props.is_preview ? true : false,
      },
      breadcrumb_items: [],
      preview_width: 1000,
      is_on_sale: this.$page.props.product.settings.on_sale ? true : false,
      options: [],
      selected: [],
      tab_index: 0,
      not_able_to_add: true,
      should_disable: false,
      not_in_duration: false,
    };
  },
  computed: {
    delivery_type() {
      let delivery_type = _.findKey(
        this.$page.props.product.attributes.delivery
      );

      switch (delivery_type) {
        case "frozen":
          return {
            name: "冷凍",
            class: "bg-fh-delivery-frozen",
            price: this.$page.props.delivery_fee[delivery_type],
          };
          break;
        case "refrigerated":
          return {
            name: "冷藏",
            class: "bg-fh-delivery-refrigerated",
            price: this.$page.props.delivery_fee[delivery_type],
          };
          break;
        case "normal":
          return {
            name: "常溫",
            class: "bg-fh-delivery-normal",
            price: this.$page.props.delivery_fee[delivery_type],
          };
          break;
      }
      return { name: "（請洽客服人員）", class: "bg-fh-delivery", price: 250 };
    },
    product_images() {
      let images = this.$page.props.product.images;
      return _.map(images, (hash, index) => {
        return {
          id: index,
          hash: hash,
        };
      });
    },
  },
  methods: {
    phraseDeliveryMethod(delivery_method) {
      switch(delivery_method) {
        case 'regular':
          return '一般物流';
          
        case '711':
        case '711_pay':
          return '7-11 店到店';
      }
    }, 
    buyNow() {},
    check_single_selection(item) {
      return (
        this.selected.some((existing) => {
          return existing.id == item.id;
        }) || this.selected.length == this.product.attributes.type.quantity
      );
    },
    check_multiple_selection(item) {
      return this.selected.length == this.product.attributes.type.quantity;
    },
    check_ability_of_add() {
      if (this.selected.length < this.product.attributes.type.quantity) {
        this.not_able_to_add = true;
        return;
      }

      this.not_able_to_add = false;
    },
    select_item(item) {
      this.selected.push(item);
      this.check_ability_of_add();
    },
    delete_item(index) {
      this.selected.splice(index, 1);

      if (this.selected.length == 0) {
        this.tab_index = 0;
      }
      this.check_ability_of_add();
    },
    addToShoppingCart() {
      fbq("track", "AddToCart", {
        content_name: this.$page.props.product.name,
      });
      console.log("fbq.track.AddToCart", {
        content_name: this.$page.props.product.name,
      });

      this.should_disable = true;

      let temp_product = {
        name: this.product.name,
        type: this.product.type,
        id: this.product.id,
        includes: this.selected,
        quantity: this.quantity,
      };

      if (
        this.product.type == "pack" &&
        this.product.attributes?.type?.mode != "fixed"
      ) {
        temp_product.includes = temp_product.includes.map((merchandise) => {
          return merchandise.id;
        });
      }

      if (
        this.product.type == "pack" &&
        this.product.attributes?.type?.mode == "fixed"
      ) {
        temp_product.includes = this.options.map((merchandise) => {
          return merchandise.id;
        });
      }

      this.$inertia.put(
        "/api/shopping-cart",
        {
          payload: [temp_product],
        },
        {
          preserveState: true,
          preserveScroll: true,
          onSuccess: (page) => {
            if (page.props.flash.shopping_cart) {
              let interval = 3000;
              switch (page.props.flash.shopping_cart.severity) {
                case "warn":
                case "error":
                  interval = 10000;
                  break;
                case "info":
                  interval = 5000;
                  break;
              }

              this.$toast.add({
                severity: page.props.flash.shopping_cart.severity,
                summary: page.props.flash.shopping_cart.summary,
                detail: page.props.flash.shopping_cart.detail,
                group: "shopping-cart",
                life: interval,
              });

              if (this.$page.props.product.type == "pack") {
                this.packInitialize();
              }
              this.quantity = 1;
            }
          },
          onFinish: (visit) => {
            this.should_disable = false;
          },
        }
      );

      // axios
      //   .put("/api/shopping-cart", {
      //     payload: [temp_product],
      //   })
      //   .then((response) => {
      //     this.$emit("update:ShoppingCart", response.data);
      //     this.$toast.add({
      //       severity: "success",
      //       summary: "成功加入購物車",
      //       detail: this.product.name + " " + this.quantity + "個",
      //       life: 3000,
      //     });

      //     this.product.includes = [];
      //     this.quantity = 1;
      //   })
      //   .catch((error) => {
      //     this.$toast.add({
      //       severity: "error",
      //       summary: "加入購物車失敗",
      //       detail: "請聯繫我們取得進一步的協助",
      //       closable: false,
      //       life: 5000,
      //     });
      //   })
      //   .finally(() => {
      //     this.should_disable = false;
      //   });
    },
    addToCollection() {
      fbq("track", "AddToWishlist", {
        content_name: this.$page.props.product.name,
      });
      console.log("fbq.track.AddToWishlist", {
        content_name: this.$page.props.product.name,
      });

      this.$inertia.post(route("user.collection"), {
        type: this.product.type,
        id: this.product.id,
      });
    },
    removeFromCollection() {
      this.$inertia.patch(route("user.collection"), {
        type: this.product.type,
        id: this.product.id,
      });
    },
    goToProductPage(slug) {
      this.$inertia.visit(route("product", slug));
    },
    setThumbnailBar(visibility) {
      this.showThumbnailBar = visibility;
    },
    setWidth(width) {
      this.preview_width = width + "px";
    },
    packInitialize() {
      this.options = _.zipWith(
        this.$page.props.product.includes,
        this.$page.props.product.includes_names,
        this.$page.props.product.includes_slugs,
        this.$page.props.product.includes_images,
        this.$page.props.product.includes_availables,
        (id, name, slug, image, available) => {
          return {
            id,
            name,
            slug,
            image,
            available,
          };
        }
      ).filter(function (option) {
        return option.available == true;
      });

      if (this.product.attributes?.type?.mode != "fixed") {
        this.selected = [];
        this.not_able_to_add = true;
      }
      this.product.multiple = this.product.attributes?.type?.mode == "multiple";
    },
    checkDuration() {
      if (this.product.settings?.time_limit ?? false) {
        if (
          this.dayjs().isBetween(
            this.product.settings.duration.start,
            this.product.settings.duration.end,
            "[)"
          )
        ) {
          this.not_in_duration = false;
          return (
            "銷售中，將於 " +
            this.dayjs(this.product.settings.duration.end).fromNow() +
            " 結束銷售。"
          );
        } else {
          if (this.dayjs().isBefore(this.product.settings.duration.start)) {
            this.not_in_duration = true;
            return (
              "將於 " +
              this.dayjs(this.product.settings.duration.start).fromNow() +
              " 開始銷售。"
            );
          }
          if (this.dayjs().isAfter(this.product.settings.duration.end)) {
            this.not_in_duration = true;
            return (
              "已於 " +
              this.dayjs(this.product.settings.duration.end).fromNow() +
              " 結束銷售。"
            );
          }
        }
      }
    },
  },
  mounted() {
    fbq("track", "ViewContent", {
      content_name: this.$page.props.product.name,
    });
    console.log("fbq.track.ViewContent", {
      content_name: this.$page.props.product.name,
    });

    if (this.$page.props.breadcrumb_paths) {
      this.breadcrumb_items.push(...this.$page.props.breadcrumb_paths);
    }

    this.breadcrumb_items.push({
      icon: "pi pi-box",
      label: this.$page.props.product.name,
      disabled: true,
    });

    if (this.$page.props.product.type == "pack") {
      this.packInitialize();
    }
  },
};
</script>

<style>
.editor_area img {
  display: inline-block;
}

.inline_galleria .p-galleria-item-nav {
  display: none;
}

.fullscreen_galleria .p-galleria-thumbnail-prev,
.fullscreen_galleria .p-galleria-thumbnail-next {
  display: none;
}

.p-galleria-thumbnail-container,
.p-galleria .p-galleria-thumbnail-container {
  border: none;
  background: none;
}

.p-button.p-button-outlined {
  border: 1px solid rgb(81 139 161);
  color: rgb(81 139 161);
}
.p-button.p-button-outlined:hover {
  border: 1px solid rgb(81 139 161);
  color: rgb(81 139 161);
}

.product-image-50 {
  width: 50px;
  height: 50px;
}
</style>

<style lang="postcss">
.p-breadcrumb {
  @apply border-0;
}
.product-header {
  @apply my-5 py-2 w-full border-fh-gray border-2 text-center text-fh-gray;
}

.p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-prev,
.p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-next {
  @apply text-fh-pink bg-fh-blue;
}

.p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-prev:hover,
.p-galleria .p-galleria-thumbnail-container .p-galleria-thumbnail-next:hover {
  @apply text-fh-blue bg-fh-pink;
}

.shopping-cart-increase_button {
  @apply border-none bg-transparent text-black;
}

.shopping-cart-decrease_button {
  @apply border-none bg-transparent text-black;
}

.shopping-cart-number_input {
  @apply border-none bg-transparent w-14 text-center;
}
</style>